// Which steps of a tour this particular person is shown.
//
// Split out of FeatureTour.jsx so it is plain JavaScript a test can import and
// run, rather than behaviour only pinned by reading the component's source.
//
// A screen rarely looks the same for everybody: controls that belong to a role
// are not rendered for anybody else. A step describing one of those has nothing
// to point at for most people, and the engine's fallback (show the card centred)
// is the wrong answer here. It is right for a panel that is merely empty today
// (no favourites yet, no bookings yet), because that person will have one
// tomorrow. It is wrong for a control they will never have: it spends a step of
// a short tour on something invisible and unreachable.
//
// So a step may declare the condition it depends on, and the page supplies the
// facts:
//
//   { title: 'Booking for somebody else', when: (c) => c.canBookForOthers }
//   <FeatureTour steps={mySteps} context={{ canBookForOthers }} />
//
// `when` is a function of the context, or a plain boolean for a condition that
// is already settled. A step without one is shown to everybody, which is almost
// all of them. Gate on a capability the page already computes for the control
// itself, never on a role name: the roles behind a capability change, and a
// second copy of the list is a second thing to forget.
export function visibleTourSteps(steps, context = {}) {
  return (steps || []).filter((step) => {
    if (!step || step.when === undefined) return true;
    return typeof step.when === 'function' ? !!step.when(context) : !!step.when;
  });
}

export default visibleTourSteps;
